import React from 'react';
import StatisticsSkeleton from '@panel/estadisticas/src/components/Skeleton';
import { isSiteWithTelBanner } from '@panel/commons/helpers';
import { select } from '@panel/commons/core/themev2';
import styled, { css } from 'styled-components';
import CardPreview from './CardPreview';
import LeadsData from './LeadsData';
import Carousel from './Carousel';
import TableArea from './TableArea';
import { LineContent } from './commonStyles';

const Skeleton = ({ device, isStatisticsByPosting, onSharedDesempeno }) => {
  return (
    <Wrapper>
      {device === 'tablet' && !onSharedDesempeno && (
        <LineContent
          width={device === 'tablet' ? '131px' : '155px'}
          marginBottom={device === 'tablet' ? '33px' : '36px'}
        />
      )}
      {device === 'mobile' && !isSiteWithTelBanner && (
        <LineContent width='155px' marginBottom='36px' marginTop={onSharedDesempeno ? '20px' : '0'} />
      )}
      {device === 'mobile' && isSiteWithTelBanner && (
        <LineContent width='155px' marginBottom='36px' marginTop={onSharedDesempeno ? '50px' : '0'} />
      )}
      {device === 'tablet' && !isSiteWithTelBanner && (
        <ContainerHeader marginTop={onSharedDesempeno ? '60px' : '0'}>
          <div>
            <LineContent width='248px' height='21px' marginBottom='8px' />
            <LineContent width='331px' marginBottom='35px' />
          </div>
          <DateSelector />
        </ContainerHeader>
      )}
      {device === 'tablet' && isSiteWithTelBanner && (
        <ContainerHeader marginTop={onSharedDesempeno ? '90px' : '0'}>
          <div>
            <LineContent width='248px' height='21px' marginBottom='8px' />
            <LineContent width='331px' marginBottom='35px' />
          </div>
          <DateSelector />
        </ContainerHeader>
      )}
      {device === 'mobile' && (
        <>
          <LineContent width='226px' marginBottom='16px' marginTop={onSharedDesempeno ? '60px' : '0'} />
          <LineContent width='155px' marginBottom='19px' />
        </>
      )}
      <Content device={device}>
        <CardPreview
          device={device}
          isStatisticsByPosting={isStatisticsByPosting}
          onSharedDesempeno={onSharedDesempeno}
        />
        {device !== 'desktop' && !isStatisticsByPosting && !onSharedDesempeno && (
          <LineContent width='155px' marginBottom={device === 'mobile' ? '74px' : '64px'} />
        )}
        {!isStatisticsByPosting ? (
          <RightArea>
            {device === 'desktop' && (
              <div className='container'>
                <div>
                  <LineContent width='248px' marginBottom='13px' />
                  <LineContent width='331px' marginBottom='31px' />
                </div>
                <DateSelector />
              </div>
            )}
            <LeadsData device={device} onSharedDesempeno={onSharedDesempeno} />
            {device === 'desktop' && !onSharedDesempeno && (
              <>
                <LineContent width='248px' marginBottom='13px' />
                <LineContent width='331px' marginBottom='19px' />
              </>
            )}
            {device === 'tablet' && !onSharedDesempeno && (
              <>
                <LineContent width='248px' height='21px' marginBottom='8px' />
                <LineContent width='331px' marginBottom='32px' />
              </>
            )}
            {device === 'mobile' && !onSharedDesempeno && (
              <>
                <LineContent width='226px' marginBottom='16px' />
                <LineContent width='155px' marginBottom='17px' />
              </>
            )}
            {!onSharedDesempeno && <Carousel device={device} />}
            <TableArea device={device} />
          </RightArea>
        ) : (
          <StatisticsSkeleton device={device} portalWithTelBanner={isSiteWithTelBanner} inDesempeno />
        )}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  .container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: ${({ marginTop }) => marginTop || 0};
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: ${({ device }) => device !== 'desktop' && 'column'};
  @media screen and (max-width: 1280px) {
    ${({ device }) =>
      device === 'desktop' &&
      css`
        margin-top: 10px;
      `}
  }
`;

const RightArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const DateSelector = styled.div`
  width: 190px;
  height: 40px;
  background: ${select('lightGray')};
  border: 1px solid ${select('middleGray')};
  border-radius: 8px;
`;

export default Skeleton;
